import {Form, Input, InputNumber, Modal} from 'antd';
import PropTypes from 'prop-types';
import {useEffect} from 'react';

const {TextArea} = Input;

export const AddFollowUp = ({
  open,
  prescriptionId,
  confirmLoading,
  onCancel,
  onSubmit,
  form,
}) => {
  useEffect(() => {
    if (open) {
      form.resetFields();

      form.setFieldsValue({
        prescriptionId,
        followUpDays: 7, // default value (optional)
        remarks: '',
      });
    }
  }, [open, prescriptionId, form]);

  return (
    <Modal
      open={open}
      title={'Add Follow Up'}
      onCancel={onCancel}
      onOk={onSubmit}
      confirmLoading={confirmLoading}
      okText={'Schedule'}
      okButtonProps={{
        className: 'bg-primary-600 hover:bg-primary-700 border-primary-600',
      }}
      cancelButtonProps={{
        className: 'border-primary-200 text-gray-600',
      }}
      destroyOnHidden
      maskClosable={false}
    >
      <Form form={form} layout={'vertical'} className={'mt-4'}>
        <Form.Item name={'prescriptionId'} hidden>
          <Input />
        </Form.Item>

        <Form.Item
          label={'Follow Up In (Days)'}
          name={'followUpDays'}
          rules={[
            {
              required: true,
              message: 'Please enter follow up days',
            },
          ]}
        >
          <InputNumber
            className={'w-full'}
            min={1}
            placeholder={'e.g. 7'}
          />
        </Form.Item>

        <Form.Item
          label={'Remarks'}
          name={'remarks'}
          rules={[
            {
              required: true,
              message: 'Please enter remarks',
            },
          ]}
        >
          <TextArea
            rows={3}
            placeholder={'Enter follow up remarks'}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

AddFollowUp.propTypes = {
  open: PropTypes.bool.isRequired,
  prescriptionId: PropTypes.string,
  confirmLoading: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
};

export default AddFollowUp;
